// Formats value to currency
export const currency = (value: number): string => !!value ? '$' + value.toFixed(2) : '';

export const addressToStr = (address: any): string => {
	if (!address) return '';
	let addressStr = '';
	if (address.AddressLine1) addressStr += address.AddressLine1;
	if (address.AddressLine2) addressStr += ' ' + address.AddressLine2;
	if (address.City) addressStr += ' ' + address.City;
	if (address.StateCode) addressStr += ', ' + address.StateCode;
	if (address.Zip) addressStr += ' ' + address.Zip;
	if (address.ZipPlus) addressStr += '-' + address.ZipPlus;
	return addressStr;
};

export const pascalToReadable = (value: string): string => value.split(/(?=[A-Z])/).join(' ');
